<template>
  <div class="bigEvent newEvent workout" :class="{floating: !inplace}"
       :style="inplace ? {} : {left: ev.position.left + 'px', top: ev.position.top + 'px'}">
  <v-form @submit.prevent="saveWorkout" novalidate>
    <div class="event-header">
      <span class="event-date">{{ ev.datetime.date() }} <template v-if="$mq == 'sm'">({{ ev.datetime.format('ddd')}})</template></span>
      <span class="event-name">
        <v-select
            class="event-select"
            v-model="workout.workout_type"
            @change="workoutTypeChange"
            :items="allWorkoutsTemplatesOptions"
            dark
            dense
        >
        </v-select>
      </span>
      <span class="event-actions">
        <v-icon dark class="click-effect ml-2" v-tooltip="'Zamknij'" @click.stop="$emit('close')">close</v-icon>
      </span>
    </div>
    <div class="event-content">
      <workout-form-element v-for="(el, index) of workout.elements" :element="el" :errors="errors.elements ? errors.elements[index] : {}" :key="index"
        @remove-element="removeElement" @add-element="addNewElement" @type-change-element="elementTypeChange"
        @distance-recalculate="distanceRecalculate"
      >
      </workout-form-element>

      <v-text-field
          v-model="workout.total_distance_planned"
          label="Suma kilometrów"
          :error="hasErrors('total_distance_planned')"
          :error-messages="getErrors('total_distance_planned')"
      >
        <v-icon slot="prepend" v-tooltip="'Suma kilometrów'">mdi-sigma</v-icon>
      </v-text-field>
      <v-textarea
          v-model="workout.additional_info"
          label="Informacje dodatkowe"
          :error="hasErrors('additional_info')"
          :error-messages="getErrors('additional_info')"
          auto-grow
          box
      >
        <v-icon slot="prepend" v-tooltip="'Informacje dodatkowe'">info</v-icon>
      </v-textarea>

      <div class="save-button-container">
        <v-btn small class="very-small" color="primary" type="submit">
          zapisz
          <v-icon right small >save</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="event-footer">
    </div>
  </v-form>
  </div>
</template>

<script>
import {createWorkout, updateWorkout} from './api'
import { mapGetters } from 'vuex'
import * as types from '@/store/mutation-types'
import iziToast from 'izitoast'
import WorkoutFormElement from './WorkoutFormElement'

export default {
  components: {WorkoutFormElement},
  props: {
    ev: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errors: {},
      workoutTemplate: null,
      workout: {}
    }
  },
  watch: {
    'workout.workout_type': {
      handler: function (val, oldVal) {
        if (oldVal === undefined && !this.isNew) {
          return
        }
        this.workoutTypeChange(val)
      }
    }
  },
  computed: {
    ...mapGetters(['allWorkoutsTemplatesOptions', 'getWorkoutTemplateByName', 'runner']),
    isNew () {
      return this.workout.id === undefined
    }
  },
  created () {
    this.$store.dispatch(types.ALL_WORKOUTS_TEMPLATES_REQUEST).then(() => {
      this.initWorkout()
    })
  },
  methods: {
    initWorkout () {
      this.workout = {...this.ev}
      if (this.isNew) {
        this.$set(this.workout, 'elements', [])
        this.$set(this.workout, 'style', 'standard')
        if (this.workout.workout_type) {
          this.workoutTypeChange(this.workout.workout_type)
        }
      } else {
        this.workoutTemplate = this.getWorkoutTemplateByName(this.workout.workout_type)
        for (let element of this.workout.elements) {
          // tutaj dla skomplikowanych wielokrotnych elementów będzie to znacznie uproszczone
          element.multiple = false
          element.first = true
          element.next = false
          element.types = [element.element_type]
          this.setElementInputs(element)
        }
      }
    },
    distanceRecalculate () {
      let distance = 0
      for (let element of this.workout.elements) {
        let v = parseFloat(element.distance_string)
        if (!isNaN(v)) {
          distance += v
        }
      }
      if (distance > 0) {
        this.$set(this.workout, 'total_distance_planned', distance)
      }
    },
    workoutTypeChange (value) {
      this.resetErrors()
      this.$set(this.workout, 'elements', [])
      this.workoutTemplate = this.getWorkoutTemplateByName(value)
      this.$set(this.workout, 'style', this.workoutTemplate.style)
      for (let element of this.workoutTemplate.elements) {
        let el = {}
        el.multiple = element.multiple
        el.first = true
        el.next = false
        el.types = element.element_types
        if (element.element_types.length === 1) {
          el.element_type = element.element_types[0]
          this.setElementInputs(el)
          if (el.hasPulse && ['OWB1', 'OWB1+R', 'OWB1+SB', 'OWB1+R+SB'].indexOf(el.element_type) > -1 &&
              this.runner.real_heart_rate_zone) {
            el.pulse = this.runner.real_heart_rate_zone
          } else {
            el.pulse = ''
          }
          if (el.hasPace && ['OWB1', 'OWB1+R', 'OWB1+SB', 'OWB1+R+SB'].indexOf(el.element_type) > -1 &&
              !this.runner.real_heart_rate_zone) {
            el.pace = this.runner.heart_rate_zone || ''
          } else {
            el.pace = ''
          }
        }
        this.workout.elements.push(el)
      }
    },
    elementTypeChange (el, value) {
      this.$set(el, 'element_type', value)
      this.setElementInputs(el)
      if (el.hasPulse && ['OWB1', 'OWB1+R', 'OWB1+SB', 'OWB1+R+SB'].indexOf(el.element_type) > -1 &&
          this.runner.real_heart_rate_zone) {
        el.pulse = this.runner.real_heart_rate_zone
      } else {
        el.pulse = ''
      }
      if (el.hasPace && ['OWB1', 'OWB1+R', 'OWB1+SB', 'OWB1+R+SB'].indexOf(el.element_type) > -1 &&
          !this.runner.real_heart_rate_zone) {
        el.pace = this.runner.heart_rate_zone || ''
      } else {
        el.pace = ''
      }
    },
    addNewElement (el) {
      let newEl = Object.assign({}, el)
      newEl.first = false
      newEl.next = true
      let index = this.workout.elements.indexOf(el)
      this.workout.elements.splice(index + 1, 0, newEl)
      if (this.errors && this.errors.elements) {
        this.errors.elements.splice(index + 1, 0, {})
      }
    },
    removeElement (el) {
      let index = this.workout.elements.indexOf(el)
      this.workout.elements.splice(index, 1)
      if (this.errors && this.errors.elements) {
        this.errors.elements.splice(index, 1)
      }
    },
    setElementInputs (el) {
      let et = el.element_type
      if (!et) {
        return
      }
      this.$set(el, 'hasDistance', false)
      this.$set(el, 'hasDistanceString', false)
      this.$set(el, 'hasPulse', false)
      this.$set(el, 'hasPace', false)
      this.$set(el, 'hasRepeats', false)
      this.$set(el, 'hasStrength', false)
      this.$set(el, 'hasBreak', false)
      this.$set(el, 'hasAscent', false)
      this.$set(el, 'hasDescent', false)
      this.$set(el, 'hasTrip', false)
      this.$set(el, 'hasOther', false)
      this.$set(el, 'hasWarmup', false)
      this.$set(el, 'hasCooling', false)

      if (et === 'OWB1') {
        el.hasDistanceString = true
        el.hasPulse = true
        el.hasPace = true
      } else if (et === 'OWB1+R') {
        el.hasDistanceString = true
        el.hasPulse = true
        el.hasPace = true
        el.hasRepeats = true
      } else if (et === 'OWB1+SB') {
        el.hasDistanceString = true
        el.hasPulse = true
        el.hasPace = true
        el.hasStrength = true
      } else if (et === 'OWB1+R+SB') {
        el.hasDistanceString = true
        el.hasPulse = true
        el.hasPace = true
        el.hasStrength = true
        el.hasRepeats = true
      } else if (et === 'STD') {
        el.hasDistanceString = true
        el.hasPulse = true
        el.hasPace = true
      } else if (et === 'R') {
        el.hasRepeats = true
      } else if (et === 'SB') {
        el.hasStrength = true
      } else if (et === 'R + SB') {
        el.hasStrength = true
        el.hasRepeats = true
      } else if (et === 'SPEED') {
        el.hasDistanceString = true
        el.hasBreak = true
        el.hasPulse = true
        el.hasPace = true
      } else if (et === 'ASCENT') {
        el.hasAscent = true
        el.hasDescent = true
        el.hasPulse = true
        el.hasPace = true
      } else if (et === 'TRIP') {
        el.hasTrip = true
      } else if (et === 'LOCATION') {
        el.hasTrip = true
      } else if (et === 'OTHER') {
        el.hasOther = true
      } else if (et === 'WARMUP') {
        el.hasWarmup = true
      } else if (et === 'COOLING') {
        el.hasCooling = true
      }

      if (!el.hasDistance) {
        el.distance = undefined
      }
      if (!el.hasDistanceString) {
        el.distance_string = undefined
      }
      if (!el.hasPulse) {
        el.pulse = undefined
      }
      if (!el.hasPace) {
        el.pace = undefined
      }
      if (!el.hasRepeats) {
        el.repeats = undefined
      }
      if (!el.hasStrength) {
        el.strength = undefined
      }
      if (!el.hasBreak) {
        el.break_time = undefined
      }
      if (!el.hasAscent) {
        el.ascent = undefined
      }
      if (!el.hasDescent) {
        el.descent = undefined
      }
      if (!el.hasTrip) {
        el.trip_location = undefined
        el.trip_link = undefined
      }
      if (!el.hasOther) {
        el.other = undefined
      }
      if (!el.hasWarmup) {
        el.warmup = undefined
      }
      if (!el.hasCooling) {
        el.cooling = undefined
      }
    },
    saveWorkout () {
      if (this.isNew) {
        var promise = createWorkout(this.runner, this.workout).then((data) => {
          this.$emit('created-workout', data)
          iziToast.show({
            message: 'Trening został dodany',
            color: 'green'
          })
          return data
        })
      } else {
        promise = updateWorkout(this.runner, this.workout).then((data) => {
          this.$emit('updated-workout', data, this.ev)
          iziToast.show({
            message: 'Trening został zmieniony',
            color: 'green'
          })
          return data
        })
      }
      promise.catch((data) => {
        if (data.response.status === 400) {
          this.errors = data.response.data
        }
      })
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    resetErrors () {
      this.errors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/WorkoutForm.vue